// extracted by mini-css-extract-plugin
module.exports = {"BannerContainer":"style_BannerContainer__345pH","CompanyBanner":"style_CompanyBanner__1JwBg","BannerItem":"style_BannerItem__1v3aG","BannerActive":"style_BannerActive__2rE2-"};